
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ClassMetadata, ExecutionResult, GridMetadata, IDocument, PaymentSelectionContext, PaymentViewModel, VoidChecksCriteria } from "@tylertech/tyler-api-types";

/**
 * PaymentService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class PaymentService<TPayment = unknown, TDetail = unknown> {
    constructor(private readonly $apiService: ApiService) { }
    
    CreatePaymentsFromSelection(pCritieria: PaymentSelectionContext): Promise<void> {
        return this.$apiService.sendAuth("IPaymentService/CreatePaymentsFromSelection", pCritieria);
    }
    GetMetadataManualCheckDetailDialog(): Promise<GridMetadata> {
        return this.$apiService.sendAuth("IPaymentService/GetMetadataManualCheckDetailDialog");
    }
    GetMetadataManualCheckDialog(): Promise<ClassMetadata> {
        return this.$apiService.sendAuth("IPaymentService/GetMetadataManualCheckDialog");
    }
    GetMetadataVoidDialog(): Promise<ClassMetadata> {
        return this.$apiService.sendAuth("IPaymentService/GetMetadataVoidDialog");
    }
    GetNewPayment(): Promise<TPayment> {
        return this.$apiService.sendAuth("IPaymentService/GetNewPayment");
    }
    GetNewPaymentDetail(): Promise<TDetail> {
        return this.$apiService.sendAuth("IPaymentService/GetNewPaymentDetail");
    }
    GetPayment(pPaymentId: string): Promise<ExecutionResult<PaymentViewModel>> {
        return this.$apiService.sendAuth("IPaymentService/GetPayment", pPaymentId);
    }
    GetPayments(filterString?: string): Promise<TPayment[]> {
        return this.$apiService.sendAuth("IPaymentService/GetPayments", null, filterString);
    }
    PrintManualCheck(payment: TPayment): Promise<IDocument[]> {
        return this.$apiService.sendAuth("IPaymentService/PrintManualCheck", payment);
    }
    PrintReports(pCriteria: VoidChecksCriteria): Promise<IDocument[]> {
        return this.$apiService.sendAuth("IPaymentService/PrintReports", pCriteria);
    }
    SaveCheckImages(itemIds: string[]): Promise<ExecutionResult<string[]>> {
        return this.$apiService.sendAuth("IPaymentService/SaveCheckImages", itemIds);
    }
    ValidatePayments(itemIds: string[]): Promise<ExecutionResult<string[]>> {
        return this.$apiService.sendAuth("IPaymentService/ValidatePayments", itemIds);
    }
    VoidPayment(pCriteria: VoidChecksCriteria): Promise<VoidChecksCriteria> {
        return this.$apiService.sendAuth("IPaymentService/VoidPayment", pCriteria);
    }
}
